import React from "react";
import {AccountContainer} from '../../components/containers/AccountContainer';

export function AccountPage() {
  return <AccountContainer />;
}
